import { render, staticRenderFns } from "./IcArrowDown.vue?vue&type=template&id=e52dc0b4&scoped=true"
import script from "./IcArrowDown.vue?vue&type=script&lang=js"
export * from "./IcArrowDown.vue?vue&type=script&lang=js"
import style0 from "./IcArrowDown.vue?vue&type=style&index=0&id=e52dc0b4&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e52dc0b4",
  null
  
)

export default component.exports